import classNames from 'classnames';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';

export interface EcoStickyFullScreenCardProps extends ImgVideoProps {
    /**
     * 标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;

    /**
     * 自定义类名
     */
    className?: string;
}

/**
 * 单屏锁屏
 */
const EcoStickyFullScreenCard: React.FC<EcoStickyFullScreenCardProps> = ({ isVideo, pc, h5, title, desc, className }) => {
    const prefixCls = `eco-sticky-full-screen-card`;
    const refComp = useRef<any>(null);
    const [enterA, setEnterA] = useState(false); //是否进入动画
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-enter`]: enterA,
    });
    useEffect(() => {
        const initEnterHandle = () => {
            const options = {
                rootMargin: '100px', //偏移量,-100px表示从底部伸出100px了
                threshold: 0, //0 - 1;0表示监听元素有部分进入了可视区
            };

            const observer = new IntersectionObserver((entries) => {
                const elem = entries[0];
                if (elem.isIntersecting && elem.boundingClientRect.top > 0) {
                    //console.log("enter", "从底部进入");
                    setEnterA(true);
                } else if (elem.isIntersecting && elem.boundingClientRect.top < 0) {
                    //console.log("enter", "从顶部进入");
                    setEnterA(true);
                } else if (!elem.isIntersecting && elem.boundingClientRect.top > 0) {
                    //console.log("leave", "从底部离开");
                    setEnterA(false);
                } else {
                    //console.log("leave", "从顶部离开");
                    setEnterA(false);
                }
            }, options);

            observer.observe(refComp.current);
        };
        initEnterHandle();
    }, []);
    return (
        <div className={compCls} ref={refComp}>
            <EcoImgVideo isVideo={isVideo} pc={pc} h5={h5} />
            <div className={`${prefixCls}-msg`}>
                <div className={`${prefixCls}-info`}>
                    {title && <div className={`${prefixCls}-title`}>{title}</div>}
                    {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                </div>
            </div>
        </div>
    );
};

export default EcoStickyFullScreenCard;
